// Declares the object a component holds open (an order, an email, a thread)
// so the recorder's portal_leave / portal_return markers can say which one
// the person walked away from (kanban 0419d550). See
// services/recorderPresence.ts for the registry and the marker rows.
//
//   useRecorderObject({ order_id: orderId });   // null/undefined id = nothing open
//
// Keys follow the recorder target convention (order_id, email_id,
// thread_ref, thread_id). Re-registers when an id changes, unregisters on
// unmount.

import { useEffect } from 'react';
import { registerRecorderObject, type RecorderObjectTargets } from '../services/recorderPresence';

export function useRecorderObject(targets: RecorderObjectTargets | null | undefined): void {
  const entries = Object.entries(targets ?? {}).filter(
    ([, v]) => v !== null && v !== undefined && v !== '',
  );
  // A stable key so the effect only re-runs when an id actually changes.
  const key = entries.map(([k, v]) => `${k}=${String(v)}`).join('&');
  useEffect(() => {
    if (!key) return undefined;
    const open: RecorderObjectTargets = {};
    for (const [k, v] of entries) open[k] = v;
    return registerRecorderObject(open);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
